module.exports = __webpack_public_path__ + "0c4f4cede77b27e283d329cc3b1838a5.fbx";